var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7183 8.45337H32.4683",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0933 5.07837V11.8284",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32617 30.9521C6.7093 28.558 8.6981 26.5701 11.0928 25.188C13.4874 23.8059 16.2036 23.0783 18.9685 23.0784C21.7334 23.0784 24.4496 23.806 26.8442 25.1882C29.2388 26.5703 31.2276 28.5583 32.6107 30.9523",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.413 17.1978C26.8114 18.8221 25.7537 20.2382 24.3668 21.276C22.9799 22.3137 21.3229 22.9289 19.5948 23.0478C17.8667 23.1666 16.1411 22.7839 14.6252 21.9458C13.1093 21.1077 11.8677 19.8497 11.0494 18.323C10.2311 16.7963 9.87106 15.0658 10.0124 13.3395C10.1538 11.6131 10.7906 9.96425 11.8464 8.59103C12.9021 7.2178 14.3319 6.1786 15.9639 5.59826C17.596 5.01792 19.3609 4.92113 21.0466 5.31952",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/UserPlus.1ce0169fd52de3492e17deea0a8dc80f.svg";
export { ForwardRef as ReactComponent };